enum SnowflakeWarehouseSizeEnum {
  XSmall = "xSmall",
  Small = "small",
  Medium = "medium",
  Large = "large",
  XLarge = "xLarge",
  XXLarge = "xxLarge",
  XXXLarge = "xxxLarge",
  X4Large = "x4Large",
  X5Large = "x5Large",
  X6Large = "x6Large"
}

const SnowflakeWarehouseSizeEnumDescription: Record<SnowflakeWarehouseSizeEnum, string> = {
  [SnowflakeWarehouseSizeEnum.XSmall]: "X-Small",
  [SnowflakeWarehouseSizeEnum.Small]: "Small",
  [SnowflakeWarehouseSizeEnum.Medium]: "Medium",
  [SnowflakeWarehouseSizeEnum.Large]: "Large",
  [SnowflakeWarehouseSizeEnum.XLarge]: "X-Large",
  [SnowflakeWarehouseSizeEnum.XXLarge]: "2X-Large",
  [SnowflakeWarehouseSizeEnum.XXXLarge]: "3X-Large",
  [SnowflakeWarehouseSizeEnum.X4Large]: "4X-Large",
  [SnowflakeWarehouseSizeEnum.X5Large]: "5X-Large",
  [SnowflakeWarehouseSizeEnum.X6Large]: "6X-Large"
};

/**
 * Returns the numeric index (0..9) for the provided WarehouseSizeEnum.
 * If an unknown value is passed, -1 is returned.
 */
function getWarehouseSizeValue(size: SnowflakeWarehouseSizeEnum): number {
  if (!size) return -1;

  switch (size) {
    case SnowflakeWarehouseSizeEnum.XSmall:
      return 0;
    case SnowflakeWarehouseSizeEnum.Small:
      return 1;
    case SnowflakeWarehouseSizeEnum.Medium:
      return 2;
    case SnowflakeWarehouseSizeEnum.Large:
      return 3;
    case SnowflakeWarehouseSizeEnum.XLarge:
      return 4;
    case SnowflakeWarehouseSizeEnum.XXLarge:
      return 5;
    case SnowflakeWarehouseSizeEnum.XXXLarge:
      return 6;
    case SnowflakeWarehouseSizeEnum.X4Large:
      return 7;
    case SnowflakeWarehouseSizeEnum.X5Large:
      return 8;
    case SnowflakeWarehouseSizeEnum.X6Large:
      return 9;
    default:
      return -1;
  }
}

export { SnowflakeWarehouseSizeEnum, SnowflakeWarehouseSizeEnumDescription, getWarehouseSizeValue };